const BASE_URL = process.env.REACT_APP_USER_API_URL;

/**
 * Wrapper around fetch that targets the user API and attaches the standard
 * JSON + bearer-token headers. Callers keep full control over response
 * handling (response.ok / response.status / response.json()).
 *
 * @param {string} path Path beginning with "/", relative to the user API base URL.
 * @param {RequestInit} [options] Standard fetch options. Any headers provided are merged last.
 * @returns {Promise<Response>}
 */
export default function authFetch(path, options = {}) {
    const token = localStorage.getItem("token");
    const { headers, ...rest } = options;
    return fetch(`${BASE_URL}${path}`, {
        ...rest,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            ...headers,
        },
    });
}
